import { render, staticRenderFns } from "./Investment.vue?vue&type=template&id=3a4628ff&scoped=true"
import script from "./Investment.vue?vue&type=script&lang=js"
export * from "./Investment.vue?vue&type=script&lang=js"
import style0 from "./Investment.vue?vue&type=style&index=0&id=3a4628ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4628ff",
  null
  
)

export default component.exports